export type EasingFn = (x: number) => number;
export type EasingScheme = Array<EasingFn>;
export type Point = { x: number; y: number };

export const inOutCubic: EasingFn = (x) =>
  x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2;
export const inOutQuad: EasingFn = (x) => (x < 0.5 ? 2 * x * x : 1 - Math.pow(-2 * x + 2, 2) / 2);
export const inQuad: EasingFn = (x) => x * x;
export const outQuad: EasingFn = (x) => 1 - (1 - x) * (1 - x);
export const linear: EasingFn = (x) => x;
export const inOutSine: EasingFn = (x) => -(Math.cos(Math.PI * x) - 1) / 2;

export function ptsAtProgress(
  progress: number,
  start: number,
  duration: number,
  startPts: Array<Point>,
  endPts: Array<Point>,
  easingScheme: EasingScheme,
): Array<Point> {
  if (progress < start) {
    return startPts;
  }

  if (progress > start + duration) {
    return endPts;
  }

  const tweenProgress = (progress - start) / duration;

  return startPts.map((pt, idx) => {
    const easingFn = easingScheme[idx] || linear;
    const proportion = easingFn(tweenProgress);
    const endPt = endPts[idx];
    return {
      x: pt.x + (endPt.x - pt.x) * proportion,
      y: pt.y + (endPt.y - pt.y) * proportion,
    };
  });
}

export function rotatePoint(point: Point, angle: number, center: Point): Point {
  const cos = Math.cos(angle);
  const sin = Math.sin(angle);
  const deltaX = point.x - center.x;
  const deltaY = point.y - center.y;
  const x = cos * deltaX - sin * deltaY + center.x;
  const y = cos * deltaY + sin * deltaX + center.y;
  return { x, y };
}
